import {useState} from "react";
import {CiShop} from "react-icons/ci";
export const BrandImage=({src,className})=>{
  const [failed,setFailed]=useState(null);
  if(!src || src===failed)return <CiShop className={className} size={40} role="img" aria-label="Logotipo de tienda no disponible"/>;
  return <img src={src} alt="Logotipo de la tienda" className={className} style={{objectFit:"contain",maxHeight:40,maxWidth:"100%"}} onError={()=>setFailed(src)}/>;
};
